export default __webpack_public_path__ + "static/media/sun-horizon-2.b4def5bb.svg";